import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const MontserratFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15607'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15607)'>
				<rect
					width='20'
					height='14'
					fill='#07319C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.3809 6.99994C12.3809 6.37936 12.3809 5.66709 12.3809 5.06635C12.3809 4.32997 12.9778 3.73328 13.7142 3.73328H15.8094C16.5458 3.73328 17.1428 4.32997 17.1428 5.06635C17.1428 5.66709 17.1428 6.37936 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
					fill='#08B9D6'
				/>
				<mask
					id='mask1_2332_15607'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='12'
					y='3'
					width='6'
					height='8'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 6.99994C12.3809 6.37936 12.3809 5.66709 12.3809 5.06635C12.3809 4.32997 12.9778 3.73328 13.7142 3.73328H15.8094C16.5458 3.73328 17.1428 4.32997 17.1428 5.06635C17.1428 5.66709 17.1428 6.37936 17.1428 6.99994C17.1428 9.33328 14.7618 10.2666 14.7618 10.2666C14.7618 10.2666 12.3809 9.33328 12.3809 6.99994Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15607)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.3809 8.3999H17.1428V10.2666H15.238H14.2856H12.3809L12.3809 8.3999Z'
						fill='#A63D09'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M15.2387 4.66663H14.2864V5.59996H13.334V6.53329H14.2864V8.39996H15.2387V6.53329H16.1911V5.59996H15.2387V4.66663Z'
						fill='#262626'
					/>
				</g>
				<path
					d='M-0.915074 -0.333333H0H0.47619H0.581265L0.667345 -0.273077L3.9146 2H4.66793L8.39732 -0.284251L8.90476 -0.595057V0V0.293115C8.90476 0.510658 8.79862 0.714517 8.6204 0.839269L5.57143 2.97355V3.578L8.45876 6.00336C8.80818 6.29688 8.60063 6.86667 8.14428 6.86667C8.04397 6.86667 7.94608 6.83581 7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828M-0.915074 -0.333333L-0.214397 0.255235L3 2.95533V3.55978L-0.191154 5.79359L-0.333333 5.89311V6.06667V6.53333V7.12839L0.174104 6.81758L3.90349 4.53333H4.65683L7.8639 6.77828M-0.915074 -0.333333L7.8639 6.77828'
					fill='#DB1E36'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.33333V4.2H3.33333V6.33333C3.33333 6.70152 3.63181 7 4 7H4.57143C4.93962 7 5.23809 6.70152 5.23809 6.33333V4.2H8.38095C8.74914 4.2 9.04762 3.90152 9.04762 3.53333V3C9.04762 2.63181 8.74914 2.33333 8.38095 2.33333H5.23809V0H3.33333V2.33333H0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H3.80952V2.33333V0H4.7619V2.33333V2.8H8.57143V3.73333H4.7619V4.2V6.53333H3.80952V4.2V3.73333H0V2.8Z'
					fill='#DB1E36'
				/>
			</g>
		</svg>
	);
};

export default MontserratFlagIcon;
